export default {
  REMINDER_SET: 'REMINDER_SET',
  REMINDER_NOT_SET: 'REMINDER_NOT_SET',
} as const
